<template>
  <b-modal
    modal-class="modal-error"
    :id="modalId"
    ref="fatal-error"
    centered
    no-stacking
    no-close-on-backdrop
    no-close-on-esc
    :title="title"
    ok-only
  >
    <slot>
      <div class="error-message" v-html="message"></div>
    </slot>
  </b-modal>
</template>

<script>
import Vue from "vue";
import { ModalPlugin } from "bootstrap-vue";

Vue.use(ModalPlugin);

export default {
  props: {
    title: String,
    message: String,
    modalId: String,
  },
};
</script>